window.okeReviewsWidgetOnInit = function () {
  moveWaRButton()

  // Observe mutations for individual reviews
  const reviewMain = document.querySelector('.js-okeReviews-reviews-main')
  if (reviewMain) {
    const reviewObserver = new MutationObserver(moveReviewComponents)
    reviewObserver.observe(reviewMain, { childList: true })
    moveReviewComponents()
  }

  // Add class when toggling review controls sort
  const dropDown = document.getElementById('okeReviews-reviews-controls-sort')
  let state = false
  if (dropDown) {
    dropDown.addEventListener('click', (e) => {
      if (state === false) {
        dropDown.parentNode.classList.add('is-okeReviews-active')
        state = true
      } else {
        dropDown.parentNode.classList.remove('is-okeReviews-active')
        state = false
      }
    })
    dropDown.addEventListener('blur', (e) => {
      state = false
    })
  }
}

// Move WaR button next to aggregate side
function moveWaRButton () {
  const writeReviewButton = document.querySelector('.js-okeReviews-writeReview')
  const reviewsAggregateSide = document.querySelector('.okeReviews-reviewsAggregate-side')

  if (
    reviewsAggregateSide &&
    writeReviewButton &&
    !writeReviewButton.className.includes('is-okeReviews-hiddenButton')
  ) {
    reviewsAggregateSide.insertAdjacentElement('beforeend', writeReviewButton)
  }
}

// Move recommendation for each review
function moveReviewComponents () {
  document.querySelectorAll('.okeReviews-reviews-review').forEach(review => {
    const reviewRecommendation = review.querySelector('.okeReviews-review-recommendation')
    const reviewPrimary = review.querySelector('.okeReviews-review-primary')

    const reviewPrimaryBottom = document.createElement('div')
    reviewPrimaryBottom.className = 'okeReviews-review-primary-bottom'

    if (reviewPrimary) {
      if (reviewRecommendation) {
        reviewPrimaryBottom.insertAdjacentElement('beforeend', reviewRecommendation)
      }
      reviewPrimary.insertAdjacentElement('beforeend', reviewPrimaryBottom)
    }
  })
}
